import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

@Pipe({
	name: 'marked',
	standalone: false,
})
export class MarkedPipe implements PipeTransform {
	transform(value?: string): string {
		if (!value) {
			return '';
		}

		// Return plain HTML so Angular can sanitize it at the [innerHTML] binding.
		return marked.parse(value, { async: false }) as string;
	}
}
